module.exports = __webpack_public_path__ + "img/avatar.b87431af.png";